import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

interface CopyToClipboardProps {
  text: string;
  size?: 'small' | 'medium' | 'large';
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ text, size = 'small' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const getIconSize = () => {
    switch (size) {
      case 'small': return { fontSize: '0.8rem' };
      case 'medium': return { fontSize: '1rem' };
      case 'large': return { fontSize: '1.5rem' };
      default: return { fontSize: '1rem' };
    }
  };

  return (
    <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
      <IconButton
        onClick={handleCopy}
        size={size}
        sx={{ 
          color: copied ? 'success.main' : 'inherit',
          p: 0.5,
          ml: 0.5
        }}
      >
        {copied ? <CheckIcon sx={getIconSize()} /> : <ContentCopyIcon sx={getIconSize()} />}
      </IconButton>
    </Tooltip>
  );
};

export default CopyToClipboard; 